<template>
  <div></div>
</template>

<script>
export default {
  name: "ProductUtils",
  methods:{
    prepareSelectedProductWithoutOffer: function (product){
      if(product.variants === undefined){
        return false;
      }
      return Object.assign({}, product.variants, {price: product.price_from, title: product.title, image: product.image});
    },
    prepareSelectedProductWithOffer: function (product){
      const offerId = Object.keys(product.offers)[0];
      return product.offers[offerId];
    }
  },
}
</script>

<style scoped>

</style>
